import script from "./UiLanguageSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./UiLanguageSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./UiLanguageSwitcher.vue?vue&type=style&index=0&id=6a527e92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a527e92"]])

export default __exports__